import React from 'react';
import { Messages } from '../../../codegen/Localize';
import { DialogFooterButtonsWidget, ButtonType, DialogType, DialogPositioningBehavior } from '@tableau/widgets';
import { ReactModalOptions, ModalInstance, ReactModalService } from '../../../commonInfra/dialogs/ReactModalService';
import { ICollectionInfo } from './ICollectionInfo';
import { CollectionsResourceQuery } from './ResourceQuery/CollectionsResourceQuery';
import { CollectionVisibility, UpdateCollectionsResponseData } from './CollectionModels';
import { ToasterService, ToastType } from '../../../ts/services/ToasterService';

// TFS 1237812: Remove with CollectionsPermissions (collectionsPermissionsEnabled) feature flag

const DIALOG_WIDTH = 400;
const ACTION_DIALOG_TESTID = 'share-private-collection-warning';

export namespace SharePrivateCollectionWarningDialog {

  export const enum ResultPublicOrPrivate {
    PUBLIC = 'public',
    PRIVATE = 'private',
  }

  const Contents  = () => {
    return (
      <div style={{fontWeight: 'normal', fontSize: '12px', lineHeight: '18px', color: '#4F4F4F', letterSpacing: '0.2px'}}>
        {Messages.collectionsSharePrivateCollectionWarningDialogMessage()}
      </div>
    );
  };

  interface FooterProps {
    onCancel: () => void;
    onOk: () => void;
  }
  const Footer = (props: FooterProps) => {
    return <DialogFooterButtonsWidget
        buttons={[
          {
            handleClick: props.onCancel,
            buttonType: ButtonType.Outline,
            children: Messages.no(),
            testId: `${ACTION_DIALOG_TESTID}-no`,
          },
          {
            handleClick: props.onOk,
            buttonType: ButtonType.Primary,
            children: Messages.yes(),
            testId: `${ACTION_DIALOG_TESTID}-yes`,
          },
        ]}
        testId={`${ACTION_DIALOG_TESTID}-footer`}
      />;
  };

  export function Options(onCancel: () => void, onOk: () => void): ReactModalOptions {
    return {
      title: Messages.collectionsSharePrivateCollectionWarningDialogTitle(),
      testId: ACTION_DIALOG_TESTID,
      type: DialogType.NormalWithTitleBar,
      showCloseButton: true,
      positioningBehavior: DialogPositioningBehavior.Centered,
      dialogWidth: DIALOG_WIDTH,
      dialogBodyStyle: { maxWidth: DIALOG_WIDTH + 'px' },
      dialogContent: <Contents />,
      dialogContentStyle: { padding: 0 },
      footerContent: <Footer onCancel={onCancel} onOk={onOk}/>
    };
  }

  export function open(collection: ICollectionInfo) {
    let modalInstance: ModalInstance<ResultPublicOrPrivate>;

    const onCancel = (): void => {
      modalInstance && modalInstance.close(ResultPublicOrPrivate.PRIVATE);
    };
    const onOk = async () => {
      const updatedCollectionData = {
        luid: collection.luid,
        visibility: 'public' as CollectionVisibility
      };
      const response: UpdateCollectionsResponseData = await new CollectionsResourceQuery().update([updatedCollectionData]);
      if (response.errors && response.errors.length > 0) {
        ToasterService.instance.pop({
          type: ToastType.Error,
          text: Messages.collectionVisibilityChangedToPublicError()
        });
        return; // keep dialog open
      }
      modalInstance && modalInstance.close(ResultPublicOrPrivate.PUBLIC);
    };

    modalInstance = ReactModalService.open(Options(onCancel, onOk));
    return modalInstance.result;
  }
}
